import { PaginationProps, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';
import './HistoricTableComponent.scss';
import { DataTelemetry } from '../../../../gen/proto/api/gateway/v1/gateway_pb';
import { Command, SensorData } from '../../../../models/telemetry';

const columns: ColumnsType<DataTelemetry> = [
  {
    title: 'Fecha',
    dataIndex: 'fecha',
    key: 'timestamp',
    render: (text, record) => (
      <span>{record.timestamp ? new Date(Number(record.timestamp.seconds) * 1000).toLocaleString() : '—'}</span>
    ),
  },
  {
    title: 'Comando',
    dataIndex: ['data', 'command', 'type'],
    key: 'comando',
  },
  {
    title: 'Velocidad 1',
    dataIndex: ['data', 'command'],
    key: 'velocidad 1',
    render: (_text, record) => {
      const command = record.data?.command as Command;
      return (
        <span>
          {command?.command_speed_1.value +
            ' ' +
            command?.command_speed_1.unit +
            ' (' +
            command.command_direction_1 +
            ')'}
        </span>
      );
    },
  },
  {
    title: 'Velocidad 2',
    dataIndex: ['data', 'command'],
    key: 'velocidad 2',
    render: (_text, record) => {
      const command = record.data?.command as Command;
      return (
        <span>
          {command?.command_speed_2.value +
            ' ' +
            command?.command_speed_2.unit +
            ' (' +
            command.command_direction_2 +
            ')'}
        </span>
      );
    },
  },
  {
    title: 'Valor del sensor',
    dataIndex: ['data', 'sensors'],
    key: 'sensor',
    render: (_text: SensorData[] | undefined) => {
      const [first] = _text ?? [];
      const value = first?.value ?? '—';
      const unit = first?.unit ?? '';
      return <span>{[value, unit].filter(Boolean).join(' ')}</span>;
    },
  },
  {
    title: 'Alerta',
    dataIndex: ['data', 'alert'],
    key: 'alerta',
  },
];

type HistoricTableComponentProps = {
  data: readonly DataTelemetry[];
  pagination: PaginationProps;
  onChange: (pagination: PaginationProps) => void;
};

const HistoricTableComponent = (props: HistoricTableComponentProps) => {
  return (
    <Table
      className={'HistoricTable'}
      bordered={false}
      rowKey={(_, index) => String(index)}
      columns={columns}
      dataSource={props.data}
      pagination={{
        ...props.pagination,
        position: ['bottomCenter'],
      }}
      onChange={props.onChange}
    />
  );
};

export default HistoricTableComponent;
